import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import UserAuth from '../../services/auth';
import { RootState } from '../../stores/store';
import FullPageLoader from '../FullPageLoader';
import useNavigateToLogin from '../../hooks/useNavigateToLogin';

interface AuthGuardProps {
  children?: React.ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { navigateToLogin } = useNavigateToLogin();

  const appData = useSelector((state: RootState) => state?.AppData);
  const userDetails = useSelector((state: RootState) => state?.UserData);
  const [isAuthenticated, setAuthenticated] = useState(false);

  const token = appData?.auth?.access_token || UserAuth.accessToken || '';

  // Hook to authenticate logged in user
  useEffect(() => {
    setAuthenticated(Boolean(token && userDetails?.user?.id));
  }, [userDetails, token]);

  // Hook to redirect user without token to auth page
  useEffect(() => {
    if (!token) {
      navigateToLogin();
    }
  }, [token]);

  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <FullPageLoader />;
};

export default AuthGuard;
